import { render } from "./RestablecerPassword.vue?vue&type=template&id=5cf526d7&scoped=true"
import script from "./RestablecerPassword.vue?vue&type=script&lang=js"
export * from "./RestablecerPassword.vue?vue&type=script&lang=js"

import "./RestablecerPassword.vue?vue&type=style&index=0&id=5cf526d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf526d7"]])

export default __exports__